import { render, staticRenderFns } from "./TwitchChat.vue?vue&type=template&id=189a0f96&"
import script from "./TwitchChat.vue?vue&type=script&lang=js&"
export * from "./TwitchChat.vue?vue&type=script&lang=js&"
import style0 from "./TwitchChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports